import React from "react";
import { withHideOnErrorBoundary } from "theme/components/helpers/ErrorBoundary";
import Link from "theme/components/atoms/Typography/Link";
import Body from "theme/components/atoms/Typography/Body";
import safeHtml from "web/core/utils/safeHtml";
import { FormattedMessage } from "react-intl";

const Breadcrumb = ({ rootName, paths }) => {
  if (!paths) return null;
  return (
    <ul
      className="breadcrumb"
      itemScope
      itemType="http://schema.org/BreadcrumbList"
    >
      <li
        itemProp="itemListElement"
        itemScope
        itemType="http://schema.org/ListItem"
        className="breadcrumb__item"
      >
        <span itemProp="item">
          <Link to="/">
            {rootName ? (
              <span
                itemProp="name"
                dangerouslySetInnerHTML={{ __html: safeHtml(rootName) }}
              />
            ) : (
              <span itemProp="name">
                <FormattedMessage
                  id="components.organisms.Breadcrumb.home"
                  defaultMessage="Home"
                />
              </span>
            )}
          </Link>
        </span>
        <span className="breadcrumb__divider">&nbsp;─&nbsp;</span>
        <meta itemProp="position" content="1" />
      </li>
      {paths.filter(Boolean).map((link, index) =>
        index < paths.length - 1 ? (
          <li
            key={index}
            itemProp="itemListElement"
            itemScope
            itemType="http://schema.org/ListItem"
            className="breadcrumb__item"
          >
            <span itemProp="item">
              <Link to={link.path}>
                <span
                  itemProp="name"
                  dangerouslySetInnerHTML={{ __html: safeHtml(link.name) }}
                />
              </Link>
            </span>
            <span className="breadcrumb__divider">&nbsp;─&nbsp;</span>
            <meta itemProp="position" content={index + 2} />
          </li>
        ) : (
          <li
            key={index}
            itemProp="itemListElement"
            itemScope
            itemType="http://schema.org/ListItem"
            className="breadcrumb__item"
          >
            <span itemProp="item">
              <Body>
                <span
                  itemProp="name"
                  dangerouslySetInnerHTML={{ __html: safeHtml(link.name) }}
                />
              </Body>
            </span>
            <meta itemProp="position" content={index + 2} />
          </li>
        )
      )}
    </ul>
  );
};

export default withHideOnErrorBoundary(Breadcrumb);
